// extracted by mini-css-extract-plugin
export default {"logo":"BrandBanner_logo__i49Jc"};